import React, { useEffect } from "react"
import * as styles from "./prepare.module.scss"
import classnames from "gpages/utils/classnames"
import doorImg from "@images/prepare-door.png"
import boyImg from "@images/prepare-boy.gif"
import txtImg from "@images/prepare-txt.png"

const Prepare = React.memo(({ ready, readyData, onAnimationEnd }) => {
  const imagesReady = readyData[0]
  useEffect(() => {
    if (imagesReady) {
      // 动画结束后通知父组件
      setTimeout(() => {
        onAnimationEnd()
      }, 2500)
    }
  }, [imagesReady])

  return (
    <div
      className={classnames(styles.prepare, {
        [styles.ready]: ready,
      })}
    >
      <div
        className={classnames(styles.main, {
          [styles.start]: readyData[0], // 当奔跑小人图片加载完后才开始动画
        })}
      >
        <img src={doorImg} alt="门" className={styles.door} />
        <img src={txtImg} alt="" className={styles.txt} />
        <img src={boyImg} alt="男孩" className={styles.boy} />
        <div className={styles.loading}>
          <div className={styles.bar}></div>
        </div>
      </div>
    </div>
  )
})

Prepare.displayName = "Prepare"
export default Prepare
